import { render, staticRenderFns } from "./PhoneNumber.vue?vue&type=template&id=95715e5e&scoped=true"
import script from "./PhoneNumber.vue?vue&type=script&lang=js"
export * from "./PhoneNumber.vue?vue&type=script&lang=js"
import style0 from "./PhoneNumber.vue?vue&type=style&index=0&id=95715e5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95715e5e",
  null
  
)

export default component.exports